import React, {useEffect, useState} from 'react';

const FlightNumber = (props) => {
    const { flightNumber, codeShares } = props;

    useEffect(() => {
        if(codeShares && (
            (Array.isArray(codeShares) && codeShares.length > 0) || 
            (typeof codeShares === 'string' && codeShares.trim() !== '')
        )) {
            //console.log('codeshare flights processed:', codeShares);
        }
    }, [codeShares])

    // Helper function to check if code shares exist
    const hasCodeShares = () => {
        return codeShares && (
            (Array.isArray(codeShares) && codeShares.length > 0) || 
            (typeof codeShares === 'string' && codeShares.trim() !== '')
        );
    };

    // Helper function to get code share count
    const getCodeShareCount = () => {
        if (!codeShares) return 0;
        
        if (Array.isArray(codeShares)) {
            return codeShares.length;
        } else if (typeof codeShares === 'string') {
            return codeShares.split(',').length;
        }
        
        return 0;
    };

    // Create tooltip content for code shares
    const getTooltipContent = () => {
        if (!codeShares) {
            return 'Flight Number';
        }
        
        let codeShareNumbers = '';
        
        if (Array.isArray(codeShares)) {
            // Handle array format
            codeShareNumbers = codeShares.map(cs => 
                typeof cs === 'string' ? cs : (cs.flightNumber || cs)
            ).join(', ');
        } else if (typeof codeShares === 'string') {
            // Handle comma-separated string format
            codeShareNumbers = codeShares;
        }
        
        if (!codeShareNumbers || codeShareNumbers.trim() === '') {
            return 'Flight Number';
        }
        
        return `Code Shares: ${codeShareNumbers}`;
    };

    return (
        <span 
            style={{ 
                textAlign: 'left', 
                color: 'white', 
                fontWeight: 'bold', 
                padding: 0, 
                margin: 0,
                cursor: hasCodeShares() ? 'help' : 'default'
            }}
            data-tippy-content={getTooltipContent()}
        >
            {flightNumber}
            {hasCodeShares() && (
                <span style={{ 
                    fontSize: '10px', 
                    opacity: 0.8, 
                    marginLeft: '4px',
                    fontWeight: 'normal'
                }}>
                    +{getCodeShareCount()}
                </span>
            )}
        </span>
    );
};

export default FlightNumber;
